module.exports = __webpack_public_path__ + "static/media/bank_others.8555990e.svg";